import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/email/${ view }.vue`);
}


const Index = loadView( 'Index' );

const emailRoutes = [
    {
        path: 'mailTemplates',
        name: 'api.mailTemplates.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
];

export default emailRoutes;
